import * as React from "react";
import { Link } from "@mui/material";
import { useLanguage } from "./Language";
import { MarcRecordTable } from "./MARCRecordTable";
import { FormDialog } from "@tlc/ui/dialog/FormDialog";
import { useDialog } from "@tlc/ui/dialog/useDialog";

interface MARCDialogProps {
  resourceId: number;
}

const MARCDialog: React.FC<MARCDialogProps> = ({ resourceId }) => {
  const { open, closeDialog, openDialog } = useDialog();

  const { translate } = useLanguage();

  const iframeRef = React.useRef<HTMLIFrameElement>(null);

  const handlePrint = () => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow.focus();
      iframeRef.current.contentWindow.print();
    }
  };

  const iframeSrc = "marcrecordview?resourceId=" + resourceId;

  return (
    <React.Fragment>
      <Link underline="hover" component="button" onClick={openDialog}>
        <small>{translate("marcRecord")}</small>
      </Link>
      <FormDialog
        disableDialogContent
        formId={"marc-print-form"}
        open={open}
        onClose={closeDialog}
        headline={translate("marcRecord")}
        confirmButtonText={translate("print")}
        maxWidth="xl"
      >
        <form onSubmit={handlePrint} id="marc-print-form">
          <iframe
            ref={iframeRef}
            src={iframeSrc}
            title={translate("marcRecord")}
            style={{
              position: "absolute",
              width: 0,
              height: 0,
              border: "none",
              visibility: "hidden",
            }}
          />
        </form>
        <MarcRecordTable resourceId={resourceId} />
      </FormDialog>
    </React.Fragment>
  );
};

export default MARCDialog;
